import React from "react";

const PositionStatusInfo = ({ t, client, position, positionPointsBarWidth, distanceToNext }) => {
  const bgColor = position === 2 ? "#b4bab7" : position === 3 ? "#bc8a73" : "#99dde0";
  const getPositionText = position => {
    switch (position) {
      case 1:
        return t("statusPoints.first");
      case 2:
        return t("statusPoints.second");
      default:
        return t("statusPoints.third");
    }
  };
  return (
    <div className="level-info">
      {position > 1 ? (
        <div className="status-points-progress">
          <div className="status-progress-text"></div>
          <div className="status-progress">
            <div className="status-progress-bar position">
              <div
                className={`status-progress-bar current-points ${position}`}
                style={{ width: `${positionPointsBarWidth}%`, backgroundColor: bgColor }}
              ></div>
            </div>
          </div>
          <span>
            {t("statusPoints.pointsToNextPosition", {
              points: distanceToNext,
              nextPosition: getPositionText(position - 1),
              lblStatuspoints: client?.ranking?.lblStatuspoints,
            })}
          </span>
        </div>
      ) : (
        <div className="progress-complete">
          <div className="progress-complete-text position">{t("statusPoints.topPositionMessage")}</div>
        </div>
      )}
    </div>
  );
};

export default PositionStatusInfo;
